<div class="PGJsonEditor">
    @if (isLoading) {
        <app-pg-loading pgAnimations="FadeIn"></app-pg-loading>
    }
    <div #codeMirrorContainer class="bg-white"></div>
    @if (jsonType != null) {
        <pre class="bg-light m-0 py-1 px-2 border-top">{{jsonType}}</pre>
    }
</div>
